import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useCaseCopySchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    caseName: Yup.string().required(t("label.isRequiredValidation", { field: t("label.name") })),
  });
}
